import React from 'react';

interface IInfoProps {
	size?: string;
	strokeWidth?: string;
	title?: string;
	className?: string;
}

export const Info = ({ size = '24', strokeWidth = '1', title = 'info icon', className = '' }: IInfoProps) => {
	return (
		<svg
			role="img"
			width={size}
			height={size}
			className={`align-middle ${className}`}
			viewBox="0 0 24 24"
			fill="none"
			aria-labelledby="infoIcon">
			<title id="infoIcon">{title}</title>
			<path
				d="M5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364Z"
				stroke="#3D3D3D"
				strokeWidth={strokeWidth}
				strokeMiterlimit="10"
			/>
			<path d="M12 15.9583V12.2083V15.9583Z" fill="#3D3D3D" />
			<path
				d="M12 15.9583V12.2083"
				stroke="#3D3D3D"
				strokeWidth={strokeWidth}
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path
				d="M12 7C11.7528 7 11.5111 7.07331 11.3055 7.21066C11.1 7.34802 10.9398 7.54324 10.8452 7.77165C10.7505 8.00005 10.7258 8.25139 10.774 8.49386C10.8223 8.73634 10.9413 8.95907 11.1161 9.13388C11.2909 9.3087 11.5137 9.42775 11.7561 9.47598C11.9986 9.52421 12.2499 9.49946 12.4784 9.40485C12.7068 9.31024 12.902 9.15002 13.0393 8.94446C13.1767 8.7389 13.25 8.49723 13.25 8.25C13.25 7.91848 13.1183 7.60054 12.8839 7.36612C12.6495 7.1317 12.3315 7 12 7Z"
				fill="#3D3D3D"
			/>
		</svg>
	);
};
